var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 68.25H27.5C11.21 68.25 4.25 61.29 4.25 45V27C4.25 10.71 11.21 3.75 27.5 3.75H42.5C43.73 3.75 44.75 4.77 44.75 6C44.75 7.23 43.73 8.25 42.5 8.25H27.5C13.67 8.25 8.75 13.17 8.75 27V45C8.75 58.83 13.67 63.75 27.5 63.75H45.5C59.33 63.75 64.25 58.83 64.25 45V30C64.25 28.77 65.27 27.75 66.5 27.75C67.73 27.75 68.75 28.77 68.75 30V45C68.75 61.29 61.79 68.25 45.5 68.25Z",
    fill: "#605BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 32.2495H54.5C44.24 32.2495 40.25 28.2595 40.25 17.9995V5.99948C40.25 5.09948 40.79 4.25948 41.63 3.92948C42.47 3.56948 43.43 3.77948 44.09 4.40948L68.09 28.4095C68.72 29.0395 68.93 30.0295 68.57 30.8695C68.21 31.7095 67.4 32.2495 66.5 32.2495ZM44.75 11.4295V17.9995C44.75 25.7395 46.76 27.7495 54.5 27.7495H61.07L44.75 11.4295Z",
    fill: "#605BFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 41.25H21.5C20.27 41.25 19.25 40.23 19.25 39C19.25 37.77 20.27 36.75 21.5 36.75H39.5C40.73 36.75 41.75 37.77 41.75 39C41.75 40.23 40.73 41.25 39.5 41.25Z",
    fill: "#605BFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 53.25H21.5C20.27 53.25 19.25 52.23 19.25 51C19.25 49.77 20.27 48.75 21.5 48.75H33.5C34.73 48.75 35.75 49.77 35.75 51C35.75 52.23 34.73 53.25 33.5 53.25Z",
    fill: "#605BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/documentIcon.7fed54729d4f20862603fbad8454ed73.svg";
export { ForwardRef as ReactComponent };